import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

const toFlag = (value) => (value ? 1 : 0);

function UpdateModal({
  updating,
  settings,
  updateFireSafetySettings,
  getFireSafetySettings,
}) {
  const [formData, setFormData] = useState({
    fsis_integration_enabled: 1,
    for_new: 1,
    for_renewal: 1,
    exclude_delinquent: 1,
    for_retirement: 1,
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateFireSafetySettings(formData, () => {
      getFireSafetySettings();
      setModal({ isOpen: false });
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    setFormData({
      fsis_integration_enabled: toFlag(_.get(settings, 'fsis_integration_enabled')),
      for_new: toFlag(_.get(settings, 'for_new')),
      for_renewal: toFlag(_.get(settings, 'for_renewal')),
      exclude_delinquent: toFlag(_.get(settings, 'exclude_delinquent')),
      for_retirement: toFlag(_.get(settings, 'for_retirement')),
    });
  };

  useEffect(() => {
    onSetFormData();
  }, [settings]);

  const onCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked ? 1 : 0,
      ...(name === 'for_renewal' && !checked && { exclude_delinquent: 0 }),
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12">
            <div className="p-3">
              <div className="mb-3">
                <h5 className="mb-1 font-weight-bold">Toggle Configuration</h5>
                <small className="text-muted">
                  Select which fire safety settings should be enabled.
                </small>
              </div>

              <div className="d-flex justify-content-between align-items-center py-2 border-top">
                <div className="pr-3">
                  <label htmlFor="fsis_integration_enabled" className="mb-0">
                    FSIS Integration
                  </label>
                </div>
                <div className="custom-control custom-switch m-0">
                  <input
                    id="fsis_integration_enabled"
                    name="fsis_integration_enabled"
                    type="checkbox"
                    className="custom-control-input"
                    checked={!!_.get(formData, 'fsis_integration_enabled')}
                    onChange={onCheck}
                  />
                  <label htmlFor="fsis_integration_enabled" className="custom-control-label" />
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center py-2 border-top">
                <div className="pr-3">
                  <label htmlFor="for_new" className="mb-0">
                    New
                  </label>
                </div>
                <div className="custom-control custom-switch m-0">
                  <input
                    id="for_new"
                    name="for_new"
                    type="checkbox"
                    className="custom-control-input"
                    checked={!!_.get(formData, 'for_new')}
                    onChange={onCheck}
                  />
                  <label htmlFor="for_new" className="custom-control-label" />
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center py-2 border-top">
                <div className="pr-3">
                  <label htmlFor="for_renewal" className="mb-0">
                    Renewal
                  </label>
                </div>
                <div className="custom-control custom-switch m-0">
                  <input
                    id="for_renewal"
                    name="for_renewal"
                    type="checkbox"
                    className="custom-control-input"
                    checked={!!_.get(formData, 'for_renewal')}
                    onChange={onCheck}
                  />
                  <label htmlFor="for_renewal" className="custom-control-label" />
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center py-2 border-top">
                <div className="pr-3">
                  <label htmlFor="exclude_delinquent" className="mb-0">
                    Exclude Delinquent
                  </label>
                  {!_.get(formData, 'for_renewal') && (
                    <small className="d-block text-muted">
                      Enable Renewal first to use this option.
                    </small>
                  )}
                </div>
                <div className="custom-control custom-switch m-0">
                  <input
                    id="exclude_delinquent"
                    name="exclude_delinquent"
                    type="checkbox"
                    className="custom-control-input"
                    checked={!!_.get(formData, 'exclude_delinquent')}
                    onChange={onCheck}
                    disabled={!_.get(formData, 'for_renewal')}
                  />
                  <label htmlFor="exclude_delinquent" className="custom-control-label" />
                </div>
              </div>

              {_.get(formData, 'type') !== 'BARANGAY CLEARANCE' && (
                <div className="d-flex justify-content-between align-items-center py-2 border-top border-bottom">
                  <div className="pr-3">
                    <label htmlFor="for_retirement" className="mb-0">
                      Retirement
                    </label>
                  </div>
                  <div className="custom-control custom-switch m-0">
                    <input
                      id="for_retirement"
                      name="for_retirement"
                      type="checkbox"
                      className="custom-control-input"
                      checked={!!_.get(formData, 'for_retirement')}
                      onChange={onCheck}
                    />
                    <label htmlFor="for_retirement" className="custom-control-label" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center mt-4">
          <button
            disabled={updating}
            type="submit"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary px-4 mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="btn btn-dark px-4"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updating: PropTypes.bool.isRequired,
  settings: PropTypes.instanceOf(Object),
  updateFireSafetySettings: PropTypes.instanceOf(Function).isRequired,
  getFireSafetySettings: PropTypes.instanceOf(Function).isRequired,
};

UpdateModal.defaultProps = {
  settings: {},
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_FIRE_SAFETY_SETTINGS) > -1,
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(UpdateModal);
